const STATISTIC_QUERY_RANGE = {
    DAY: 'day',
    WEEK: 'week',
    TWO_WEEK: 'twoWeek',
    MONTH: 'month'
  };

export default {
    STATISTIC_QUERY_RANGE
};